















































import Vue from "vue";

import { formatCurrency } from "@/utility/Formatter";

import { dataTableItemsPerPage } from "@/utility/Constants";

import { GetTransactionDetailsCommand } from "@/model/communication/cashReport/GetTransactionDetailsCommand";
import { GetTransactionDetailsCommandReqData } from "@/model/communication/cashReport/GetTransactionDetailsCommandReqData";
import { DownloadTransactionAdditionalDetailsCommand } from "@/model/communication/cashReport/DownloadInstallationsEnabledModulesCommand";

import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";

export default Vue.extend({
    components: {
        ColumnVisibilityFilter,
    },
    data() {
        return {
            dataTableItemsPerPage,
            dataTableLoading: false,
            downloadLoading: false,
            availableHeaders: [],
            initialAvailableHeaders: [
                { sortable: false, enabled: false, text: this.$t("common.installationName"), value: "machineInstallationName" },
                { sortable: false, enabled: false, text: this.$t("common.machine"), value: "machineSerialNumber" },
                { sortable: false, enabled: true, text: this.$t("common.denomination"), value: "denomination" },
                { sortable: false, enabled: false, text: this.$t("cash_report.ecb_class"), value: "ecbClass" },
                { sortable: false, enabled: false, text: this.$t("common.destination"), value: "destination" },
                { sortable: false, enabled: true, text: this.$t("cash_report.serial_number") + " 1", value: "serialNumber1" },
                { sortable: false, enabled: false, text: this.$t("cash_report.serial_number") + " 2", value: "serialNumber2" },
            ],
            options: {},
            transactionDetailsLength: 0,
            transactionDetails: [],
            formatCurrency,
        };
    },
    props: {
        transactionId: String,
    },
    watch: {
        transactionId() {
            this.fetchTransactionDetails();
        },
    },
    methods: {
        async fetchTransactionDetails() {
            this.dataTableLoading = true;
            let reqData = new GetTransactionDetailsCommandReqData();
            reqData.transactionId = this.transactionId;
            reqData.offset = (this.options.page - 1) * this.options.itemsPerPage;
            reqData.limit = this.options.itemsPerPage;
            let resp = await new GetTransactionDetailsCommand(reqData).execute();
            this.transactionDetailsLength = resp.paginatedTotalItems;
            this.transactionDetails = resp.transactionAdditionalDetails;
            this.dataTableLoading = false;
        },
        async exportAs(exportType: string) {
            this.downloadLoading = true;
            try {
                const res = await new DownloadTransactionAdditionalDetailsCommand(this.transactionId, exportType).execute();

                let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                let fileLink = document.createElement("a");
                fileLink.href = fileURL;
                fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                document.body.appendChild(fileLink);
                fileLink.click();
                this.downloadLoading = false;
            } catch (e) {
                console.log("Something went wrong, server side");
                this.downloadLoading = false;
            }
        },
    },
    mounted() {
        this.fetchTransactionDetails();
    },
});
